import { Injectable } from '@angular/core';
import { INameId } from '@modeso/types__aumico-lib-core-be';

@Injectable({ providedIn: 'root' })
export class DraggableMultiSelectMapper {
    getSelectedOptionsOfSelectionOptions(selectionOptions: INameId[], selectedOptions: INameId[]): INameId[] {
        if (selectedOptions == null) {
            return null;
        }
        const selectedOptionsFromSelectionOptionsList: INameId[] = [];

        for (const selection of selectedOptions) {
            // check equality of name as some options are array of string so the id will be fake
            const isSelectionOptionFound = selectionOptions.find(
                (selectedOption) => selectedOption.name === selection.name,
            );

            if (isSelectionOptionFound != null) {
                selectedOptionsFromSelectionOptionsList.push(isSelectionOptionFound);
            }
        }
        return selectedOptionsFromSelectionOptionsList;
    }
}
